import { intToBool } from "./helpers";

const state = {
    netsuiteId: null,
    netsuiteURL: null,
    stockCode: null,
    apiData: null,
    isDealer: false,
    isSiteB2C: false,
    isSiteB2B: false,
    isCustomB2cEnabled: false,
    isSparePartEnabled: false,
    isPackageWithoutComponents: false,
    cartUrlParams: "",
    componentsStockAvailabilityAU: null,
    auStockValue: 0,
};
const mutations = {
    setApiData(state, data) {
        state.apiData = data;
    },
    setNetsuiteId(state, netsuiteId) {
        state.netsuiteId = netsuiteId;
    },
    setStockCode(state, stockCode) {
        state.stockCode = stockCode;
    },
    setNetsuiteURL(state, url) {
        state.netsuiteURL = url;
    },
    checkB2B(state, status) {
        state.isSiteB2B = intToBool(status);
    },
    checkB2C(state, status) {
        state.isSiteB2C = intToBool(status);
    },
    checkDealerUser(state, status) {
        state.isDealer = intToBool(status);
    },
    checkSparePartsSettings(state, status) {
        state.isSparePartEnabled = intToBool(status);
    },
    checkCustomB2C(state, status) {
        state.isCustomB2cEnabled = intToBool(status);
    },
    checkRegionStock(state, status) {
        state.hasRegionStock = !intToBool(status);
    },
    checkPackageWithoutComponents(state, status) {
        state.isPackageWithoutComponents = intToBool(status);
    },
    setCartUrlParams(state, params) {
        state.cartUrlParams = params;
    },
    setComponentsStockAvailabilityAU(state, params) {
        state.componentsStockAvailabilityAU = params;
    }
};

const actions = {};
const getters = {
    isAddToCartButtonVisible: (state, getters, rootState, rootGetters) => (
        standaloneData = null,
        parentNetsuiteId = null,
        isAlwaysInStock = null,
    ) => {
        let visibility = false;

        let apiData,
            components,
            isPackageInStock,
            parentProduct,
            hasRegionStock,
            isPackageWithoutComponents;

        if (standaloneData) {
            apiData = standaloneData;
            components = standaloneData;
            isPackageInStock = getters.isPackageInStock(components);
            parentProduct = getters.parentProduct(components, parentNetsuiteId);
            hasRegionStock = getters.hasRegionStock(parentProduct);
            isPackageWithoutComponents = intToBool(isAlwaysInStock);
        } else {
            apiData = state.apiData;
            components = getters.components;
            isPackageInStock = getters.isPackageInStock();
            parentProduct = getters.parentProduct();
            hasRegionStock = getters.hasRegionStock(parentProduct);
            isPackageWithoutComponents = state.isPackageWithoutComponents;
        }
        
        // hide add to cart by default
        // check that user has cart access
        if (!getters.noCartAccess) {
            // console.log("noCartAccess");
            // is site B2C or  is site B2B and is user B2B
            if ((state.isSiteB2C && parentProduct && (parentProduct.custitemavailwebaudtc == 'Sellable' || window.culture != "en-au")) || (state.isSiteB2B && state.isDealer)) {
                // console.log("is site B2C or  is site B2B and is user B2B");
                // item for sale in region
                if (hasRegionStock) {
                    if (apiData) {
                        // if product is a package
                        if (components.length > 1) {
                            // console.log('Product is a package!', isPackageInStock);
                            if (isPackageInStock) {
                                // console.log('Package visibility set true 1');
                                visibility = true;
                            } else {
                                if (state.isSiteB2B && state.isDealer) {
                                    if (getters.isPackageBackOrderable()) {
                                        if (state.isSiteB2B && state.isDealer) {
                                            // console.log("the product is backorderable");
                                            if(parentProduct){
                                                if (parentProduct.isinstock || parentProduct.isbackorderable) {
                                                    // console.log('visibility set true 2');
                                                    visibility = true;
                                                }
                                                else {
                                                    // console.log('visibility set true 3');
                                                    visibility = parentProduct.isinstock;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        } else {
                            //  product is package without components RV
                            if (isPackageWithoutComponents) {
                                // console.log("it is a RV package - always in stock");
                                // console.log('visibility set true 4');
                                visibility = true;
                            } else {
                                // console.log("the product is a single");
                                if (parentProduct) {
                                    if (state.isSiteB2B && state.isDealer) {
                                        // console.log("the product is backorderable");
                                        // console.log('visibility set true 5');
                                        visibility = parentProduct.isinstock
                                            ? parentProduct.isinstock
                                            : parentProduct.isbackorderable;
                                    } else {
                                        // console.log('visibility set true 6');
                                        visibility = parentProduct.isinstock;
                                    }
                                }
                            }
                        }
                    }
                }
                // site has spare parts
            } else if (state.isSparePartEnabled && parentProduct && parentProduct.custitem_onlinesparepart && (parentProduct.custitemavailwebaudtc == 'Sellable' || window.culture != "en-au")) {
                if (hasRegionStock) {
                    if (apiData) {
                        if (parentProduct) {
                            // console.log('visibility set true 7');
                            visibility = parentProduct.isinstock;
                        }
                    }
                }

                if ((window.culture == "en-au" && parentProduct && parentProduct.custitemonline_auweb && (parentProduct.custitemavailwebaudtc == 'Sellable' || window.culture != "en-au")) || (window.culture == "en-nz" && parentProduct.custitemonline_nzweb)) {
                    if (hasRegionStock) {
                        if (apiData) {
                            if (parentProduct) {
                                visibility = parentProduct.isinstock;
                            }
                        }
                    }
                }
            }
        }

        return visibility;
    },
    components: state => {
        return state.apiData ? state.apiData.items : null;
    },
    parentProduct: (state, getters) => (
        standaloneComponents = null,
        parentNetsuiteId = null
    ) => {
        let components, netsuiteId;

        if (standaloneComponents) {
            components = standaloneComponents;
            netsuiteId = parentNetsuiteId;
        } else {
            components = getters.components;
            netsuiteId = state.netsuiteId;
        }

        if (components) {
            if (components.length == 1) {
                return components[0];
            } else {
                let mainComponent = null;
                for (let item of components) {
                    if (item.internalid == netsuiteId) {
                        mainComponent = item;
                    }
                }
                return mainComponent;
            }
        }
        return null;
    },
    isPackageInStock: (state, getters) => (standaloneComponents = null) => {
        let components;

        if (standaloneComponents) {
            components = standaloneComponents;
        } else {
            components = getters.components;
        }

        let isPackageInStock = true;

        if (components) {
            components.map(item => {
                if (!item.isinstock) {
                    isPackageInStock = false;
                }
            });
        }
        return isPackageInStock;
    },
    isPackageBackOrderable: (state, getters) => (
        standaloneComponents = null
    ) => {
        let components;

        if (standaloneComponents) {
            components = standaloneComponents;
        } else {
            components = getters.components;
        }

        let isPackageBackOrderable = true;
        if (components) {
            components.map(item => {
                if (!item.isbackorderable) {
                    isPackageBackOrderable = false;
                }
            });
        }
        return isPackageBackOrderable;
    },
    hasRegionStock: (state, getters) => parentProduct => {
        let culture = window.culture;
        if (culture == "en-au") {
            return parentProduct
                ? !intToBool(parentProduct.custitemweb_item_not_for_sale_syd)
                : true;
        } else if (culture == "en-nz") {
            return parentProduct
                ? !intToBool(parentProduct.custitemweb_item_not_for_sale_wel)
                : true;
        } else if (culture == "en-us" || culture == "en-es") {
            return parentProduct
                ? !intToBool(parentProduct.custitemweb_item_not_for_sale_den)
                : true;
        } else {
            return true;
        }
    },
    getComponentByStockCode: (state, getters) => stockCode => {
        let component = null;
        if (getters.components) {
            for (let item of getters.components) {
                if (item.itemid.startsWith(stockCode)) {
                    if (item.itemid == stockCode) {
                        component = item;
                        break;
                    }
                    component = item;
                }
            }
        }
        return component;
    },
    noCartAccess(state, getters, rootState, rootGetters) {
        return rootGetters["auth/cartNoAccess"];
    },
    getCartUrlParams(state, getter) {
        return state.cartUrlParams;
    },
    getStockAvailabilityAU: (state) => netsuiteId =>  {
        let status = null;
        if (state.componentsStockAvailabilityAU) {
            for (let component of state.componentsStockAvailabilityAU) {
                let componentNetsuiteId = component[0];
                let componentStockStatus = component[1].stockStatus;

                if (componentNetsuiteId == netsuiteId) {
                    status = componentStockStatus;
                    break;
                }
            }
        }

        return status;
    }
};


const cart = {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}

export default cart;
